import { SaveResultMessage } from "@/components/test/SaveResultMessage";
import { Button } from "@/components/ui/button";
import {
    Table,
    TableBody,
    TableCaption,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table"

export const SMIResults = ({ scores }) => {
    const calculateSMI = (...args) => {
        const sum = args.reduce((acc, cur) => acc + (scores[cur - 1] || 0), 0);
        return {
            sum,
            avg: parseFloat((sum / args.length).toFixed(2)),
        }
    }

    const calculate = () => {
        const childModes = new Map([
            ["Уязвимый ребёнок", calculateSMI(4, 6, 36, 50, 67, 71, 105, 106, 111, 119)],
            ["Сердитый ребёнок", calculateSMI(22, 42, 47, 49, 56, 63, 76, 79, 103, 109)],
            ["Разгневанный ребёнок", calculateSMI(14, 25, 26, 46, 54, 60, 92, 98, 101, 123)],
            ["Импульсивный ребёнок", calculateSMI(12, 15, 35, 40, 66, 69, 78, 97, 110)],
            ["Необузданный ребёнок", calculateSMI(13, 21, 30, 65, 70, 107)],
            ["Счастливый ребёнок", calculateSMI(2, 17, 19, 48, 61, 68, 95, 96, 113, 122)],
        ])

        const copingModes = new Map([
            ["Послушный капитулянт", calculateSMI(8, 18, 37, 38, 55, 100, 108)],
            ["Отстранённый защитник", calculateSMI(28, 33, 34, 39, 43, 59, 64, 75, 88)],
            ["Отстранённый самоутешитель", calculateSMI(41, 52, 57, 86)],
            ["Высокомерный самовозвеличиватель", calculateSMI(10, 11, 27, 31, 44, 74, 81, 89, 91, 114)],
            ["Агрессивный задира", calculateSMI(1, 24, 32, 53, 77, 93, 99, 102, 112)],
        ])

        const parentModes = new Map([
            ["Наказывающий родитель", calculateSMI(3, 5, 9, 16, 58, 72, 84, 87, 94, 118)],
            ["Требовательный родитель", calculateSMI(7, 23, 45, 51, 82, 83, 90, 104, 115, 116)],
        ])

        const healthyModes = new Map([
            ["Здоровый взрослый", calculateSMI(20, 29, 62, 73, 80, 85, 117, 120, 121, 124)],
        ])

        return {
            childModes,
            copingModes,
            parentModes,
            healthyModes,
        }
    }

    const { childModes, copingModes, parentModes, healthyModes } = calculate()

    const data = [
        ...Array.from(childModes, ([name, val]) => ({ type: "Детские режимы", name, ...val })),
        ...Array.from(copingModes, ([name, val]) => ({ type: "Копинг-режимы", name, ...val })),
        ...Array.from(parentModes, ([name, val]) => ({ type: "Родительские режимы", name, ...val })),
        ...Array.from(healthyModes, ([name, val]) => ({ type: "Здоровые режимы", name, ...val })),
    ]

    return (
        <div className="mt-6">
            <SaveResultMessage />
            <Table>
                <TableCaption>Результаты SMI по режимам</TableCaption>
                <TableHeader>
                    <TableRow>
                        <TableHead>Тип</TableHead>
                        <TableHead>Режим</TableHead>
                        <TableHead className="text-right">Сумма</TableHead>
                        <TableHead className="text-right">Среднее</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {data.map((item, i) => (
                        <TableRow key={i}>
                            <TableCell>{i > 0 && data[i - 1].type === item.type ? null : item.type}</TableCell>
                            <TableCell>{item.name}</TableCell>
                            <TableCell className="text-right">{item.sum}</TableCell>
                            <TableCell className="text-right">{item.avg}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    )
}
